export default __webpack_public_path__ + "static/media/hero-referral.a9c1c660.svg";